export default {
  SET_TOKEN (state, token) {
    state.accessToken = token
  },
  UPDATE_TIMINGS (state, expiresIn) {
    state.expiresIn = expiresIn
    state.expiresFrom = new Date().getTime()
  },
  UPDATE_ACTIVE_REQUEST_TOGGLE (state, bool) {
    state.hasCurrentActiveRequest = bool
  }
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/mutations.js